import * as React from 'react';
import PropTypes from 'prop-types';
import { Nav, Tab } from 'react-bootstrap';
import TabTable1 from './TabTable1.js';
import TabTable2 from './TabTable2.js';
import TabTable3 from './TabTable3.js';
import TabTable4 from './TabTable4.js';

function TabsComponent({paymentForms,marksForms,uploads,checkListForms}) {
  return (
    <Tab.Container defaultActiveKey="payments">
      <Nav variant="tabs" className='tbcnt'>
        <Nav.Item>
          <Nav.Link eventKey="payments">Payments</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="mark-sheet">Mark Sheet</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="check_list">Check List</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content className='tbcnt'>
        <Tab.Pane eventKey="payments">
          <TabTable1 paymentForms={paymentForms}/>
        </Tab.Pane>
        <Tab.Pane eventKey="documents">
          <TabTable2 uploads={uploads}/>
        </Tab.Pane>
        <Tab.Pane eventKey="mark-sheet">
          <TabTable3 marksForms={marksForms}/>
        </Tab.Pane>
        <Tab.Pane eventKey="check_list">
          <TabTable4 cheklistForm={checkListForms}/> 
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
}

TabsComponent.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

export default TabsComponent;
